(function() {
    'use strict';

    angular
        .module('elogbooks.admin.pricing-schedules')
        .controller('AbsenceEntryWorkflowAddNoteController', AbsenceEntryWorkflowAddNoteController);

    AbsenceEntryWorkflowAddNoteController.$inject = [
        'absenceEntryResponse',
        'lodash',
        '$state',
        'apiClient',
        'messenger'
    ];

    function AbsenceEntryWorkflowAddNoteController(
        absenceEntryResponse,
        lodash,
        $state,
        apiClient,
        messenger
    ) {
        var vm = this;

        vm.type = lodash.last($state.current.name.split('.'));
        vm.data = { note: null };

        vm.create = vm.update = function() {
            return apiClient.create(absenceEntryResponse.getLink('workflow-' + vm.type), vm.data).then(function (response) {
                if (response) {
                    $state.go('^.^.absence-entry', {}, { reload: true }).then(function () {
                        messenger.success(
                            'ABSENCE_ENTRY_WORKFLOW_'
                            + vm.type.toUpperCase().replaceAll('-', '_')
                            + '_SUCCESS'
                        );
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        };
    }
})();
